import { render } from "./Progress.vue?vue&type=template&id=daa6ef22"
import script from "./Progress.vue?vue&type=script&lang=js"
export * from "./Progress.vue?vue&type=script&lang=js"

import "./Progress.vue?vue&type=style&index=0&id=daa6ef22&lang=css"
script.render = render

export default script